import * as Yup from 'yup';

const LoginSchema = Yup.object().shape({
  username: Yup.string().required('Username of Email address is required'),
  password: Yup.string().required('Password is required'),
});

export default LoginSchema;
